<template>
  <div class="field is-horizontal is-small">
    <div v-if="title" class="field-title">
      <small>{{ title }}</small>
    </div>
    <div
      v-if="label"
      class="field-label">
      <label class="label">{{ label }}</label>
    </div>
    <div class="field-body">
      <div class="field has-addons">
        <p v-if="prefixPosition === 'left' && prefix" class="control pos-left">
          <span class="button is-static">{{ prefix }}</span>
        </p>
        <b-input
          v-model="localValue"
          :disabled="disabled"
          :placeholder="placeholder"
          :type="inputType"
          expanded
          size="is-small" />
        <p v-if="prefixPosition === 'right' && prefix" class="control pos-right">
          <span class="button is-static">{{ prefix }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BInputExpanded',
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prefixPosition: {
      type: String,
      default: 'left'
    },
    rules: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    localValue: null,
    inputType: null
  }),
  watch: {
    value(newValue) {
      this.localValue = this.fixValue(newValue);
    },
    localValue(newValue) {
      this.$emit('input', newValue);
    }
  },
  created() {
    this.localValue = this.fixValue(this.value);
    this.inputType = Number.isNaN(this.fixValue(this.value)) ? 'text' : 'number';
  },
  methods: {
    fixValue(value) {
      if (value === null || value === undefined) return null;
      if (typeof value === 'number') return value;
      if (typeof value === 'string' && Number.isNaN(value)) return value;
      return +value;
    }
  }
};
</script>

<style>

.field-label.is-normal:empty {
  display: none;
}
.field.is-horizontal.is-small .field-body {
  display: flex;
  align-items: center;
}

.field.is-horizontal.is-small .field-label {
  padding-top: 0.375em;
}

.field.is-horizontal.is-small .field.has-addons .button.is-static {
  background-color: #EEF2F6;
  border-color: #ECEFF4;
  color: hsl(0, 0%, 48%);
  box-shadow: none;
  pointer-events: none;
  font-size: 0.75rem;
  width: 100%;
  min-width: 35px;
}
.field.is-horizontal.is-small .field.has-addons .control.pos-left .button.is-static{
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.field.is-horizontal.is-small .field.has-addons .control.pos-right .button.is-static{
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.has-addons.is-small .field-label label {
  font-size: 0.75rem !important;
  margin-right: 5px !important;
}

.field.is-horizontal.is-small .field.has-addons .control.is-expanded {
  flex-grow: 1;
}
@media screen and (max-width: 769px) {

  .field.is-horizontal.is-small{
    display: block;
  }
}

@media screen and (min-width: 525px) and (max-width: 768px) {
  /* Exclusivo tablets sin menu desplegado */
  .subcard .is-horizontal .field-label {
    flex-grow: 2;
  }
}
</style>
